export default {
  init() {
    // JavaScript to be fired on all pages
    $('.timetable').each((i, timetable) => {
      const $timetable = $(timetable),
            $timetableContainer = $timetable.closest('.table-container');

      $timetable.clone(true).appendTo($timetableContainer).addClass('clone');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/components/timetable.js